module.exports = __webpack_public_path__ + "media/newstyle/images/new-icon-twitter-4459642e890fa25f6d889cc2a037c592.svg";